import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'fcp-other-insurance',
    templateUrl: './other-insurance.component.html',
    styleUrls: ['./other-insurance.component.scss']
})
export class OtherInsuranceComponent implements OnInit {
    @Input() data: any;

    constructor() { }

    ngOnInit() { }

}
